<template>
  <m-field
    :data-testid="testId"
    class="text-field-wrapper flex-1"
    :class="`text-area-${$.uid}`"
    :status="hasError ? 'danger' : 'default'">
    <m-field-label v-if="label" slot="label" :data-testid="`${testId}-label`">
      {{ label }}

      <help-tooltip v-if="hint" :text="hint" />
    </m-field-label>
    <m-text-area
      resize="none"
      :style="`${computedWidth};max-width: 100%;`"
      :class="{ 'is-compact': isCompact }"
      @input="event => (internalValue = event.target.value)"
      :name="fieldName"
      :placeholder="placeholder"
      :value="lazyValue"
      @focus="handleFocus"
      @blur="handleBlur"></m-text-area>
    <m-field-hint :data-testid="`${testId}-errors`">
      {{ errorBucket.join(', ') }}
    </m-field-hint>
  </m-field>
</template>

<script>
import fieldMixin from '@/components/mixins/fieldMixin';
import validatable from '@/components/mixins/validatable';
import testable from '@/components/mixins/testable';
import { HelpTooltip } from '@/components';

export default {
  name: 'TextArea',
  mixins: [fieldMixin, testable, validatable],
  components: { HelpTooltip },
  props: {
    /**
     * @model
     */
    modelValue: {
      type: String,
      required: false
    },
    /**
     * Sets height of textarea to more compact size
     */
    isCompact: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted() {
    this.util.appendStyleToShadowDomEl(
      document.querySelector(`.text-area-${this.$.uid} > m-text-area`),
      'textarea',
      'padding: 0 2px !important; font-size:16px !important;'
    );
    if (this.isCompact) {
      this.util.appendStyleToShadowDomEl(
        document.querySelector(`.text-area-${this.$.uid} > m-text-area`),
        'textarea',
        'min-height:50px;max-height:50px;min-block-size:50px !important;'
      );
    }
  }
};
</script>

<style lang="scss" scoped>
m-text-area.is-compact {
  min-height: 60px;
  max-height: 60px;
}
</style>
